// kept in this module (not consts.js) since consts.js -> ExamPreview -> MonitoringFlags -> consts.js would
// otherwise be a circular import, and these constants are read at module scope in MonitoringFlags.js
// (TDZ error, not just unused-var) - see src/utils/mobileCameraLog.js (feature/15690) for the same pattern

// Codes written by the backend into exam.monitoringError (desktop monitoring channel)
export const MONITORING_FLAGS = {
	REPLAY_SUSPECTED: 'REPLAY_SUSPECTED',
	MONITORING_CONTENDED: 'MONITORING_CONTENDED',
	MONITORING_RESET: 'MONITORING_RESET',
	CLOCK_DRIFT: 'CLOCK_DRIFT',
	PERMISSION_DENIED: 'PERMISSION_DENIED',
	PROCESS_LIST_ERROR: 'PROCESS_LIST_ERROR',
	// Operational - anyone knowing the examId can trigger it blindly, so it is not a trustworthy tamper signal
	CHALLENGE_DESYNC: 'CHALLENGE_DESYNC',
	// Operational, but important for assessment - the recording may be truncated
	VIDEO_RECHECK_BUDGET_SPENT: 'VIDEO_RECHECK_BUDGET_SPENT',
	// Operational - infrastructure outage on our side, anti-replay checks were bypassed for its duration
	MONITORING_DEGRADED: 'MONITORING_DEGRADED',
};

// Indications of a tampered or emulated desktop client - everything else is operational context
export const SECURITY_MONITORING_FLAGS = [MONITORING_FLAGS.REPLAY_SUSPECTED, MONITORING_FLAGS.MONITORING_CONTENDED];
